import { required, email, minLength } from "@vuelidate/validators";
import { notEqual } from "../validators";
import { subjects } from "../lookups";
import { useVuelidate } from "@vuelidate/core";
import isProduction from "../helpers/isProduction";

export default class ContactMail {

  constructor() {
    this.reset();
  }

  name = "";
  email = "";
  subject = "";
  msg = "";

  rules = {
    name: { required, minLength: minLength(5) },
    email: { required, email },
    subject: {
      required,
      minLength: minLength(5),
      notEqual: notEqual(subjects[0]),
    },
    msg: { required, minLength: minLength(20) }
  };

  getModel() {
    return useVuelidate(this.rules, this, { $rewardEarly: true });
  }

  reset() {
    if (isProduction) {
      this.name = "";
      this.email = "";
      this.subject = "";
      this.msg = "";
    } 
  }
}